import { SharedWebsocket } from "common/utils/sharedWebsocket";
import { SubscriptionManager } from "common/hooks/subscriptionManager";
import React, { createContext, FC, PropsWithChildren, useContext } from "react";

export const WebSocketContext = createContext<SharedWebsocket>(
  new SharedWebsocket()
);
export const SubscriptionManagerContext = createContext<SubscriptionManager>(
  new SubscriptionManager()
);

export const WebSocketProvider: FC<PropsWithChildren> = ({ children }) => {
  const sharedWebsocket = useContext(WebSocketContext);
  const subscriptionManager = useContext(SubscriptionManagerContext);
  return (
    <WebSocketContext.Provider value={sharedWebsocket}>
      <SubscriptionManagerContext.Provider value={subscriptionManager}>
        {children}
      </SubscriptionManagerContext.Provider>
    </WebSocketContext.Provider>
  );
};
